export default "__VITE_PUBLIC_ASSET__bd331c7c__"